import {
  REMINDERS_BATCH_DELETE_REQUEST,
  REMINDERS_BATCH_DELETE_SUCCESS,
  REMINDERS_BATCH_DELETE_FAILURE,
  REMINDERS_FETCH_MANY_REQUEST,
  REMINDERS_FETCH_MANY_SUCCESS,
  REMINDERS_FETCH_MANY_FAILURE,
  REMINDERS_FETCH_REQUEST,
  REMINDERS_FETCH_SUCCESS,
  REMINDERS_FETCH_FAILURE,
  REMINDERS_SAVE_REQUEST,
  REMINDERS_SAVE_SUCCESS,
  REMINDERS_SAVE_FAILURE,

  EMPTY_REMINDERS,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(REMINDERS_BATCH_DELETE_REQUEST)
    return window.axios.post('/reminders', { _method: 'DELETE', ids }).then(response => {
      commit(REMINDERS_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(REMINDERS_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1, extraParams = {} }) {
    commit(REMINDERS_FETCH_MANY_REQUEST)
    return window.axios.get('/reminders', { params: { query, page, ...extraParams } }).then(response => {
      commit(REMINDERS_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(REMINDERS_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(REMINDERS_FETCH_REQUEST)
    return window.axios.get(`/reminders/${id}`).then(response => {
      commit(REMINDERS_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(REMINDERS_FETCH_FAILURE, error)
      throw error
    })
  },
  markComplete({ commit }, id) {
    return window.axios.post(`/reminders/mark-complete/${id}`).then(response => {
      return response
    }).catch(error => {
      throw error
    })
  },
  save ({ commit }, user) {
    const path = user.id ? `/reminders/${user.id}` : '/reminders'
    const method = user.id ? 'put' : 'post'

    commit(REMINDERS_SAVE_REQUEST)
    return window.axios[method](path, user).then(response => {
      commit(REMINDERS_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(REMINDERS_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(REMINDERS_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_REMINDERS);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
